module.exports = __webpack_public_path__ + "fondo-servicios-grande.44ee8bf6e7d45d4d424b.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/diego/Documents/SirisWebSite/WebSite/src/assets/images/fondo-servicios-grande.jpg
// module id = ../../../../../src/assets/images/fondo-servicios-grande.jpg
// module chunks = styles